import { createSelector } from 'reselect'

export const numAdsPerPage = (state) => {
  return state.classified.numAdsPerPage
}

export const getRequestedAd = (state) => state.classified.requestedAd.ad

export const getBreadcrumbs = (state) => state.classified.requestedAd.breadcrumbs

export const getBreadcrumbsOmitLast = createSelector(
  [getBreadcrumbs],
  (breadcrumbs) => {
    if (!breadcrumbs) {
      return []
    }

    const mutatedArr = [...breadcrumbs]
    mutatedArr.pop()
    return mutatedArr
  },
)
